import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createReceipt } from "../../actions/receiptActions";
import { createBill, billAll } from "../../actions/billActions";
import Select from 'react-select';


import classnames from "classnames";

class ProcessAcount extends Component {
  constructor() {
    super();
    this.state = {
      cycleDate: "",
      amount: "",
      billAmount: "",
      receiptNumber: "",
      receiptDate: "",
      billDate: "",
      billAllDate: "",
      description: "",
      notes: "",
      institution: "",
      nationalId: "",
      currency: '',
      billNationalId: "",
      errors: {},
    };
    this.saveReceipt = this.saveReceipt.bind(this);
    this.saveBill = this.saveBill.bind(this);
    this.billAll = this.billAll.bind(this);
    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
  }

  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  saveReceipt = (e) => {
    e.preventDefault();
    let receipt = {
      receiptDate: this.state.receiptDate,
      amount: this.state.amount,
      receiptNumber: this.state.receiptNumber,
      notes: this.state.notes,
      nationalId: this.state.nationalId,
      currency: this.state.currency,
    };

    this.props.createReceipt(receipt, this.props.history);

    this.setState({ receiptDate: "", amount: "", receiptNumber: "", notes: "", nationalId: "", currency: "" })
  };

  saveBill = (e) => {
    e.preventDefault();
    let bill = {
      billDate: this.state.billDate,
      amount: this.state.billAmount,
      notes: this.state.description,
      nationalId: this.state.billNationalId,
      currency: this.state.currency
    };

    this.props.createBill(bill, this.props.history);
    this.setState({ billDate: "", amount: "", notes: "", nationalId: "", currency: "" })
  };

  handleCurrencyChange(val) {
    this.setState({ currency: val.value });
  }
  billAll = (e) => {
    e.preventDefault();
    let billDate = this.state.billAllDate;

    this.props.billAll(billDate, this.props.history);
  };

  render() {
    const { errors } = this.state;
    const currencies = [{ value: "ZWL", label: "ZWL" }, { value: "USD", label: "USD" },{value:"ZWG",label:"ZWG"}]

    return (
      <div className="container mt-5">
        <div className="card m-auto  shadow-lg rounded p-3">
          <h5 className="display-4 text-center">Process Member Account</h5>
          <p className="lead text-center">Receipting/Billing</p>
          <hr />
          {errors.message && (
            <div className="alert alert-danger text-center" role="alert">
              {errors.message}
            </div>
          )}
          <div className="row">
            <div className="col-sm-4">
              <div className="card ">
                <div className="card-header bg-primary"><h5>Individual Receipt</h5></div>
                <div className="card-body">
                  <form onSubmit={this.saveReceipt}>
                    <div className="form-group">
                      <label>NationalId</label>
                      <input
                        className={classnames("form-control", {
                          "is-invalid": errors.nationalId,
                        })}
                        type="text"
                        name="nationalId"
                        id="nationalId"
                        value={this.state.nationalId}
                        onChange={this.onChange}
                        placeholder="NationalId"
                      />
                      {errors.nationalId && (
                        <div className="invalid-feedback">
                          {errors.nationalId}
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Receipt Date</label>
                      <input
                        className={classnames("form-control", {
                          is_invalid: errors.receiptDate,
                        })}
                        type="date"
                        name="receiptDate"
                        onChange={this.onChange}
                        value={this.state.receiptDate || ""}
                      />
                      {errors.receiptDate && (
                        <div className="invalid-feedback">
                          {errors.receiptDate}
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Amount</label>
                      <input
                        className={classnames("form-control", {
                          "is-invalid": errors.amount,
                        })}
                        type="number"
                        name="amount"
                        id="amount"
                        value={this.state.amount}
                        onChange={this.onChange}
                        placeholder="Amount"
                      />
                      {errors.amount && (
                        <div className="invalid-feedback">{errors.amount}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Currency</label>
                      <Select
                        className="react-selectcomponent"
                        classNamePrefix="name-select"
                        onChange={this.handleCurrencyChange}
                        options={currencies}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Receipt Number</label>
                      <input
                        className={classnames("form-control", {
                          "is-invalid": errors.receiptNumber,
                        })}
                        type="text"
                        name="receiptNumber"
                        id="receiptNumber"
                        value={this.state.receiptNumber}
                        onChange={this.onChange}
                        placeholder="Receipt Number"
                      />
                      {errors.receiptNumber && (
                        <div className="invalid-feedback">
                          {errors.receiptNumber}
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Description</label>
                      <input
                        className={classnames("form-control", {
                          "is-invalid": errors.notes,
                        })}
                        type="text"
                        name="notes"
                        id="notes"
                        value={this.state.notes || ""}
                        onChange={this.onChange}
                        placeholder="Notes"
                      />
                      {errors.notes && (
                        <div className="invalid-feedback">{errors.notes}</div>
                      )}
                    </div>

                    <div className="card-footer">
                      <button
                        type="submit"
                        className="btn btn-success btn-block mt-2"
                      >
                        Save Receipt
                    </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card" >
                <div className="card-header  bg-success"><h5>Individual Bill</h5></div>
                <div className="card-body">
                  <form onSubmit={this.saveBill}>
                    <div className="form-group">
                      <label>NationalId</label>
                      <input
                        className={classnames("form-control", {
                          "is-invalid": errors.nationalId,
                        })}
                        type="text"
                        name="billNationalId"
                        id="billNationalId"
                        value={this.state.billNationalId}
                        onChange={this.onChange}
                        placeholder="NationalId"
                      />
                      {errors.nationalId && (
                        <div className="invalid-feedback">{errors.nationalId}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Bill Date</label>
                      <input
                        className={classnames("form-control", {
                          is_invalid: errors.billDate,
                        })}
                        type="date"
                        name="billDate"
                        onChange={this.onChange}
                        value={this.state.billDate || ""}
                      />
                      {errors.billDate && (
                        <div className="invalid-feedback">{errors.billDate}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Amount</label>
                      <input
                        className={classnames("form-control", {
                          "is-invalid": errors.amount,
                        })}
                        type="number"
                        name="billAmount"
                        id="billAmount"
                        value={this.state.billAmount}
                        onChange={this.onChange}
                        placeholder="Amount"
                      />
                      {errors.amount && (
                        <div className="invalid-feedback">{errors.amount}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Currency</label>
                      <Select
                        className="react-selectcomponent"
                        classNamePrefix="name-select"
                        onChange={this.handleCurrencyChange}
                        options={currencies}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Notes</label>
                      <input
                        className={classnames("form-control", {
                          "is-invalid": errors.notes,
                        })}
                        type="text"
                        name="description"
                        id="description"
                        value={this.state.description || ""}
                        onChange={this.onChange}
                        placeholder="Notes"
                      />
                      {errors.notes && (
                        <div className="invalid-feedback">{errors.notes}</div>
                      )}
                    </div>

                    <div className="card-footer">
                      <button
                        type="submit"
                        className="btn btn-primary btn-block mt-2"
                      >
                        Save Bill
                  </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div col-sm-4>
              <div className="card  ml-4" >
                <div className="card-header bg-warning"><h5>Bill All</h5></div>
                <div className="card-body">
                  <form onSubmit={this.billAll}>
                    <div>
                      <div className="form-group">
                        <label>Bill Date</label>
                        <input
                          className={classnames("form-control", {
                            is_invalid: errors.billDate,
                          })}
                          type="date"
                          format="mm-yyyy"
                          name="billAllDate"
                          onChange={this.onChange}
                          value={this.state.billAllDate || ""}
                        />
                        {errors.billDate && (
                          <div className="invalid-feedback">{errors.billDate}</div>
                        )}
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary btn-block mt-2"
                      >
                        Bill All
                  </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProcessAcount.propTypes = {
  createReceipt: PropTypes.func.isRequired,
  createBill: PropTypes.func.isRequired,
  billAll: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.errors,
});

export default connect(mapStateToProps, { createReceipt, createBill, billAll })(
  ProcessAcount
);
